// extracted by mini-css-extract-plugin
export default {"container":"xp-z","amazonPayLink":"yp-z","disabled":"zp-z"};